import React, { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Label,
} from "recharts";
import styled from "styled-components";
import { parseDate, useParsedStartDate } from "../../utils/ParseDate";
const Button = styled.button`
  cursor: pointer;
  border-radius: 6px;
  border: 1px solid #a2a2a2;

  background: ${(props) => (props.selected ? props?.is_custom : '#ffff')};

      width: ${(props) => props?.incres == true ? '107px' : '107px'};
    height: 34px;
  color: ${(props) => (props.selected ? '#ffff' : '#292A2A')};
  font-family: inherit;
  font-weight: 600;
  font-style: Semi Bold;
  font-size: 14px;
  leading-trim: NONE;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  text-transform: capitalize;
`;
const TabsDiv = styled.div`
    display: flex;
    margin-top: 10px;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: justify;
    justify-content: space-between;
    width: 93%;
    margin-left: auto;
    margin-right: auto;
}
`;

const TitleDiv = styled.div`
    display: flex;
    margin-top: 10px;
    align-items: center;
    justify-content: space-between;
    width: 93%;
    margin-left: auto;
    margin-right: auto;
`;

const AlertTrendsChart = ({personalDetailsData}) => {
  const [selectedButton, setSelectedButton] = useState('Months');
  const [selectedChannel, setSelectedChannel] = useState('twitter');
  const { configureAlert } = useSelector((state) => state.alert);
  const handleButtonClick = (val) => {
    setSelectedButton(val)
  }


  const data = useMemo(() => {
    const alerts = configureAlert?.get_weekly_alerts;
    if (!alerts) return [];

    switch (selectedButton) {
      case 'Months':
        return alerts.month ?? [];
      case 'Weeks':
        return alerts.week ?? [];
      case 'Days':
        return alerts.day ?? [];
      default:
        return [];
    }
  }, [configureAlert?.get_weekly_alerts, selectedButton]);
  const cleanedData2 = useMemo(() => {
    if (!data) return [];

    return data.map(item => ({
      ...item,
      user_engagement: item.user_engagement === 0 ? null : item.user_engagement,
      sentiment_negative: item.sentiment_negative === 0 ? null : item.sentiment_negative,
      sentiment_positive: item.sentiment_positive === 0 ? null : item.sentiment_positive,
      grammar_check: item.grammar_check === 0 ? null : item.grammar_check,
    }));
  }, [data]);

  const cleanedData = useMemo(() => {
    if (!data) return [];

    // return configureAlert?.channel_data
    //   ?.filter((i) => i.channel_name === selectedButton)
    //   ?.map((item) => ({
    //     name: capitalize(item?.alert_name),          // label
    //     value: item?.triggered_count,    // number
    //     fill: "rgba(45, 137, 85, 1)",                 // bar color
    //   }));

    return data
      ?.filter((i) => i.channel?.split(',').includes(selectedChannel))
      // .map(item => ({
      //    let startDateParsed = useParsedStartDate(
      //       false,
      //       item?.date,
      //       item?.date,
      //       'dd/MM/yyyy'
      //     )
      ?.sort((a, b) => {

      let dateA, dateB;

      if (selectedButton === 'Months') {
        // 'yyyy-MM' → treat as first day of the month
        dateA = new Date(`${a.period}-01`);
        dateB = new Date(`${b.period}-01`);
      } else {
        // 'yyyy-MM-dd'
        dateA = new Date(a.date);
        dateB = new Date(b.date);
      }

      return dateA - dateB;
    })
      .map((item) => {
        // const startDateParsed = useParsedStartDate(
        //   false,
        //   item?.date,
        //   item?.date,
        //   'dd/MM/yyyy'
        // );
        let newDate = ''
        if (selectedButton == 'Days' ) {
          newDate = parseDate(item?.date, 'yyyy-MM-dd', 'dd/MM/yyyy');
          console.log(newDate, selectedChannel, "newDate");

        } else if(selectedButton == 'Weeks'){
          // newDate = item?.date
          newDate = parseDate(item?.date, 'yyyy-MM-dd', 'dd/MM/yyyy');
        }else if(selectedButton == 'Months'){
          let [year,month] = item?.period?.split('-')
          console.log(year,month,"year");
          
          newDate = `${month}/${year}`
        } else {

          newDate = item?.period
        }

        return ({
          ...item,
          period: newDate || '',
          user_engagement: item.user_engagement === 0 ? null : item.user_engagement,
          sentiment_negative: item.sentiment_negative === 0 ? null : item.sentiment_negative,
          sentiment_positive: item.sentiment_positive === 0 ? null : item.sentiment_positive,
          grammar_check: item.grammar_check === 0 ? null : item.grammar_check,
        })
      });
  }, [data, selectedChannel]);



  const renderDot = (color) => (props) => {
    const { cx, cy, value } = props;
    if (!value) return null;  // hides 0, null, undefined
    return <circle cx={cx} cy={cy} r={4} fill={color} />;
  };


  return (
    <div style={{ width: "100%", height: 330 }}>
      <TitleDiv >
        <h3 style={{ textAlign: "center", margin: "0px", fontSize: '15px', fontWeight: '500' }}>
          Alert Trends Over Time
        </h3>


      </TitleDiv>
      <TabsDiv>
        <div style={{ display: 'flex' }}>
          <Button
            incres={false}
            is_custom={personalDetailsData?.is_custom == 'custom' && personalDetailsData?.selected_items ? personalDetailsData?.selected_items :'linear-gradient(95.02deg, #A0D925 -65.35%, #006A68 100%)'}
          
            style={{ borderRadius: '6px 0px 0px 6px' }}
            selected={selectedChannel === 'twitter'}
            onClick={() => setSelectedChannel('twitter')}
          >
            X
          </Button>
          <Button
            incres={true}
            is_custom={personalDetailsData?.is_custom == 'custom' && personalDetailsData?.selected_items ? personalDetailsData?.selected_items :'linear-gradient(95.02deg, #A0D925 -65.35%, #006A68 100%)'}
          
            style={{ borderRadius: '0px 6px 6px 0px'}}
            selected={selectedChannel === 'instagram'}
            onClick={() => setSelectedChannel('instagram')}
          >
            Instagram
          </Button>
        </div>
        <div style={{ display: 'flex' }}>
          <Button
            incres={false}
            is_custom={personalDetailsData?.is_custom == 'custom' && personalDetailsData?.selected_items ? personalDetailsData?.selected_items :'linear-gradient(95.02deg, #A0D925 -65.35%, #006A68 100%)'}
          
            style={{ borderRadius: '6px 0px 0px 6px'}}
            selected={selectedButton === 'Days'}
            onClick={() => handleButtonClick('Days')}
          >
            Days
          </Button>
          <Button
            incres={true}
            is_custom={personalDetailsData?.is_custom == 'custom' && personalDetailsData?.selected_items ? personalDetailsData?.selected_items :'linear-gradient(95.02deg, #A0D925 -65.35%, #006A68 100%)'}
          
            style={{ borderRadius: '0px' }}
            selected={selectedButton === 'Weeks'}
            onClick={() => handleButtonClick('Weeks')}
          >
            Weeks
          </Button>
          <Button
            incres={true}
            is_custom={personalDetailsData?.is_custom == 'custom' && personalDetailsData?.selected_items ? personalDetailsData?.selected_items :'linear-gradient(95.02deg, #A0D925 -65.35%, #006A68 100%)'}
          
            style={{ borderRadius: '0px 6px 6px 0px' }}
            selected={selectedButton === 'Months'}
            onClick={() => handleButtonClick('Months')}
          >
            Months
          </Button>
        </div>

      </TabsDiv>
      <ResponsiveContainer height={300} width={'98%'}>
        <LineChart
          data={cleanedData || []}

          margin={{ top: 20, right: 40, left: 30, bottom: 10 }}
        // margin={{ top: 20, right: 30, left: 40, bottom: 20 }}
        >
          {/* <CartesianGrid strokeDasharray="3 3" /> */}
          <XAxis
            dataKey="period"
            tick={{ fontSize: 13, fontFamily: "Inter" }}
          />
          <YAxis width={Math.max(...(cleanedData?.map(d => 
          Math.max(d.user_engagement||0, d.sentiment_negative||0, d.sentiment_positive||0, d.grammar_check||0)) || [0])).toString().length * 10 + 50}
            allowDecimals={false}
            tick={{ fontSize: 13, fontFamily: "Inter" }}>
            <Label
              value="Number of Alerts Triggered"
              angle={-90}
              position="insideLeft"
              style={{ fontSize: 14, textAnchor: "middle", fontFamily: "Inter" }}
              offset={10}
            />
          </YAxis>
          <Tooltip labelFormatter={(label) => {

            let parts = label.split('/');
            console.log(parts,"parts");
            
            if (parts.length === 3) {
              const [day, month, year] = parts;

              // Create a new Date object with the provided date values
              const dateVal = new Date(year, month - 1, day); // months are 0-indexed in JavaScript
              if (isNaN(dateVal?.getTime())) {
                return 'Invalid Date'; // Return a default error message if invalid
              }
              // Format the date as 'Month Day, Year' (e.g., March 15, 2023)
              const options = { year: 'numeric', month: 'long', day: 'numeric' };
              return new Intl.DateTimeFormat('en-US', options).format(dateVal);
            }

            if (parts.length === 2) {
              const [month, year] = parts;
              if (month && year) {
                // Create a date using the first day of the given month and year
                const dateVal = new Date(year, month - 1, 1); // months are 0-indexed in JavaScript
                if (isNaN(dateVal?.getTime())) {
                  return 'Invalid Date';
                }

                // Format it as 'Month Year' (e.g., January 2024)
                const options = { year: 'numeric', month: 'long' };
                return new Intl.DateTimeFormat('en-US', options).format(dateVal);
              }
            }

            // Return the year only if the string is just a year
            if (parts.length === 1 ) {
              return parts[0]; // Return the year as is (e.g., 2024)
            }


            return `${label}`
          }
          }
            contentStyle={{
              fontSize: '13px',
              fontFamily: 'Inter'
            }} />
          {/* <Legend verticalAlign="top" height={36} /> */}
          <Line
            type="monotone"
            dataKey="user_engagement"
            stroke="#4aa273"
            name="Engagement Spike"
            strokeWidth={2}
            connectNulls
          />
          <Line
            type="monotone"
            dataKey="sentiment_negative"
            stroke="#32610d"
            name="Negative Sentiment"
            strokeWidth={2}
            connectNulls
          />
          <Line
            type="monotone"
            dataKey="sentiment_positive"
            stroke="#075275"
            name="Positive Sentiment"
            strokeWidth={2}
            connectNulls
          />
          <Line
            type="monotone"
            dataKey="grammar_check"
            stroke="rgb(7, 82, 118)"
            name="Grammar Alerts"
            strokeWidth={2}
            connectNulls
          />
          <Line
            type="monotone"
            dataKey="emotions_neutral"
            stroke="#FDE3A2"
            name="Neutral Alerts"
            strokeWidth={2}
            connectNulls
          />
          <Line
            type="monotone"
            dataKey="emotions_joy"
            stroke="#E651CE"
            name="Joy Alerts"
            strokeWidth={2}
            connectNulls
          />
          <Line
            type="monotone"
            dataKey="emotions_surprise"
            stroke="#4FD786"
            name="Surprise Alerts"
            strokeWidth={2}
            connectNulls
          />
          <Line
            type="monotone"
            dataKey="emotions_anger"
            stroke="#F14239"
            name="Anger Alerts"
            strokeWidth={2}
            connectNulls
          />
          <Line
            type="monotone"
            dataKey="emotions_disgust"
            stroke="#8862D3"
            name="Disgust Alerts"
            strokeWidth={2}
            connectNulls
          />
          <Line
            type="monotone"
            dataKey="emotions_fear"
            stroke="#FFB84D"
            name="Fear Alerts"
            strokeWidth={2}
            connectNulls
          />
          <Line
            type="monotone"
            dataKey="emotions_sadness"
            stroke="#5C9BDB"
            name="Sadness Alerts"
            strokeWidth={2}
            connectNulls
          />
          

        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default AlertTrendsChart;
